<template>
  <div class="war-room-commission-earn-banner-card">
    <slot name="header" />
    <div class="war-room-commission-earn-banner-card__content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WarRoomCommissionEarnBannerCard',
};
</script>

<style scoped lang="scss">
.war-room-commission-earn-banner-card {
  box-shadow: var(--theme-elevation-01);
  border: 1px solid var(--blue-10);
  border-radius: 8px;
  background: var(--theme-color-card);
  overflow: hidden;

  &__content {
    padding: 12px 16px 16px;
  }
}
</style>
